jQuery(document).ready(function($) {
    var slider = $(".expansion-slider-wrapper");
    
	slider.each(function() {
        let slickData = {
			dots: true,
			infinite: false,
			arrows: true,
			prevArrow: $(this).closest(".expansion-slider").find(".prev-slide"),
			nextArrow: $(this).closest(".expansion-slider").find(".next-slide"),
			speed: 300,
			slidesToScroll: 1,
			focusOnSelect: true,
			draggable: true,
			variableWidth: true,
			swipeToSlide: true
        }

        // Change which dots it should use based on screen size
        if (window.innerWidth > 650) {
			slickData.appendDots = $(this).closest(".expansion-slider").find(".dots-wrapper.large");
        } else {
			slickData.appendDots = $(this).closest(".expansion-slider").find(".dots-wrapper.small");
        }

		$(this).slick(slickData);
	});

	calculateHeight();
	setTimeout(function() {
		$(document).foundation('equalizer','reflow');
	},1000);
	calculateHeight();
	
	slider.find(".link").on("click", function(e) {
		e.preventDefault();
		slider.find(".link").not(this).parent().removeClass("open");
        $(this).parent().toggleClass("open");
        $(this).closest('article.slide').toggleClass("active");
    });
});

jQuery(window).on('resize', function() {
    calculateHeight();
});

function calculateHeight() {
    var slider = jQuery(".expansion-slider-wrapper"),
        // img = slider.find("img").outerHeight(),
		img = 450,
        link = slider.find(".link").outerHeight();

    slider.find("article.slide").height(img + link);
	slider.find(".content-wrapper").css("top", "calc(100% - " + link + "px)");
}
